import React from "react"
import { useSaisieDeclarationST } from "./Usesaisiedeclarationst"
import StepUploadFacture from "./Stepuploadfacture"
import StepReviewForm from "./Stepreviewform"

interface Props {
     consultantId: number
     mois: string
     annee: string
     onSuccess: () => void
}

const SaisieDeclarationConsultantST = ({ consultantId, mois, annee, onSuccess }: Props) => {
     const { state, handlers } = useSaisieDeclarationST(consultantId, mois, annee, onSuccess)

     return (
          <div className="p-4">
               {state.step === "upload" && <StepUploadFacture isExtracting={state.isExtracting} onDrop={handlers.handleFactureDrop} />}

               {state.step === "review" && state.extracted && state.factureFile && (
                    <StepReviewForm
                         factureFile={state.factureFile}
                         extracted={state.extracted}
                         fraisFiles={state.fraisFiles}
                         isSaving={state.isSaving}
                         onUpdateField={handlers.updateField}
                         onAddFraisFiles={handlers.addFraisFiles}
                         onRemoveFraisFile={handlers.removeFraisFile}
                         onSubmit={handlers.handleSubmit}
                         onReset={handlers.reset}
                    />
               )}
          </div>
     )
}

export default SaisieDeclarationConsultantST
